export const LOADING_MESSAGE_ACTIONS = [
  'Analyzing',
  'Crunching',
  'Loading',
  'Processing',
  'Calculating',
  'Fetching',
  'Gathering',
  'Mining',
  'Extracting',
  'Compiling',
];

export const LOADING_MESSAGE_SUBJECTS = [
  'trends',
  'numbers',
  'insights',
  'data',
  'metrics',
  'patterns',
  'records',
  'statistics',
  'volumes',
  'analytics',
];
